import React from "react";
import { Ban } from "lucide-react";

/**
 * Tombstone for a soft-deleted ("delete-from-inbox") message. The backend
 * strips the body for deleted rows; this is purely local — the recipient's
 * copy on WhatsApp is unaffected (the Cloud API can't recall messages).
 */
const DeletedMessage = ({ message }) => (
  <span className="wa-msg__deleted">
    <Ban size={12} />
    {message.direction === "outbound" ? "You deleted this message" : "This message was deleted"}
  </span>
);

export default DeletedMessage;
